import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';
import { HEDGING_HEDGE_BOOK_QUERY_KEY } from './hedge-book';
import { HEDGING_EXPOSURE_QUERY_KEY } from './exposure';
import { HEDGING_POSITION_MATCHING_QUERY_KEY } from './position-matching';
import { HEDGING_SPREAD_PL_QUERY_KEY } from './spread-pl';
import { HEDGING_ALERTS_QUERY_KEY } from './alerts';

export interface CloseFxHedgePayload {
  hedgeRequestId: string;
  closeQuantity: string;
  executedRate: string;
  valueDate: string;
  contractReference?: string;
  notes?: string;
}

export interface FxCloseResponse {
  id: string;
  hedgeRequestId: string;
  executionType: string;
  direction: string;
}

const INVALIDATE_KEYS = [
  [HEDGING_HEDGE_BOOK_QUERY_KEY],
  HEDGING_EXPOSURE_QUERY_KEY,
  HEDGING_POSITION_MATCHING_QUERY_KEY,
  HEDGING_SPREAD_PL_QUERY_KEY,
  HEDGING_ALERTS_QUERY_KEY,
] as const;

export function useCloseFxHedge() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CloseFxHedgePayload) =>
      apiRequest<FxCloseResponse>('/hedging/fx-close', { method: 'POST', body: input }),
    onSuccess: async () => {
      await Promise.all(
        INVALIDATE_KEYS.map((key) => queryClient.invalidateQueries({ queryKey: key })),
      );
    },
  });
}
